import React from 'react';

import { Fade, PopoverProps, Typography } from '@mui/material';
import CloseButton from 'components/CloseButton';

import { StyledCustomPopoverHeaderWrap, StyledNotificationsPopover } from './styled';

export interface CustomPopoverProps extends PopoverProps {
	onCloseButtonClick: () => void;
}

function CustomPopover({ children, title, onCloseButtonClick, ...props }: CustomPopoverProps) {
	return (
		<StyledNotificationsPopover TransitionComponent={Fade} {...props}>
			<StyledCustomPopoverHeaderWrap>
				<Typography variant="h4">{title}</Typography>
				<CloseButton onClick={onCloseButtonClick} background />
			</StyledCustomPopoverHeaderWrap>
			{children}
		</StyledNotificationsPopover>
	);
}

export default CustomPopover;
